export const ROUTES = {
  home: '/',
  signIn: '/sign-in',
  signUp: '/sign-up',
  accountType: '/account-type',
  complete: '/sign-up-complete',
  privacy: `/privacy-policy`,
  about: `/about-us`,
  terms: `/terms-of-purchase`,
  resetPasswordInstructions: '/reset-password/email',
  resetPasswordNewPassword: '/reset-password/new',
  resetPasswordSuccess: '/reset-password/success',
  resetPassword: '/reset-password',
  feed: '/dashboard/feed',
  overview: '/dashboard/overview',
  webshop: '/dashboard/webshop',
  settings: '/dashboard/settings',
  benefits: '/dashboard/benefits',
  benefit: (id: string | number) => `/dashboard/benefits/${id}`,
  createBenefits: '/dashboard/benefits/create',
  editBenefit: (id: string | number) => `/dashboard/benefits/${id}/edit`,
  merchants: '/dashboard/merchants',
  merchantsRequest: (id: string | number) =>
    `/dashboard/merchants/request/${id}`,
  organisationRequest: (id: string | number) =>
    `/dashboard/organisations/request/${id}`,
  members: '/dashboard/members',
  notifications: '/dashboard/notifications',
  organisations: '/dashboard/organisations',
  subscriptions: '/dashboard/subscriptions',
  addOrganisationSubscription: '/dashboard/subscriptions/add',
  subscriptionDetails: '/dashboard/subscriptions/organisation',
  webshopPreview: '/dashboard/webshop-preview',
  addMerchants: '/dashboard/merchants/add',
  addOrganisations: '/dashboard/organisations/add',
  cashback: '/dashboard/cashback',
  cashbackOverview: '/dashboard/cashback/overview',
  finances: '/dashboard/finances',
  invoice: (id: string | number) => `/dashboard/finances/invoice/${id}`,
  fundsBreakdown: (id: string) => `/dashboard/finances/breakdown/${id}`
};
